<template>
    <div>
        <a :href="nextLink" class="mb-5 d-block">Click on this link to sign in with Xumm</a>

        <p class="mb-5">or scan this code in your XUMM app</p>

        <img :src="qr" alt="QR Code"/><br>
    </div>
</template>

<script>
export default {
    name: "XummLogin",

     props: {
         nextLink: String,
         channel: String,
         qr: String
     },

    created: function () {
        window.Echo.channel(this.channel)
            .listen('XummMessageReceived', (e) => {
                if(e.message.connected) {
                    window.location.replace(e.message.url);
                }
            });
    }
}
</script>
